(function() {

    'use strict';

    angular.module('app').
    controller('AreasController', AreasController);

    AreasController.$inject = [
        'AreasTableService', 
        '$routeParams'
    ];

    function AreasController(
        AreasTableService, 
        $routeParams
    ){
        const vm = this;
        vm.areasTableData = new AreasTableService({
            areaId: $routeParams.areaId ? $routeParams.areaId.split(',') : []
        }).tableData;
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/routes/AreasController.js